import { TODO } from '@b2c/types/index';
import angular from 'angular';
import { DaysServiceModule } from '../days/days.services';
import { CalendarServiceModule } from '../calendar/calendar.service';
import { QueryStringBuilderFactoryModule } from '@b2c/common/factories/QueryStringBuilder/QueryStringBuilder.factory';
import { ApiVersionFactoryModule } from '@b2c/common/factories/apiVersion/apiVersion.factory';
import { HelpersServiceModule } from '../helpers/helpers.service';

export const EventsServiceModule = angular.module('acme.common.service.events', [
  CalendarServiceModule,
  HelpersServiceModule,
  DaysServiceModule,
  QueryStringBuilderFactoryModule,
  ApiVersionFactoryModule
])
.service('EventsService', [ '$http', '$filter', 'QueryStringBuilderFactory', 'CalendarService', 'HelpersService', 'DaysService', 'ApiVersionFactory', function($http, $filter, QueryStringBuilderFactory, CalendarService, HelpersService, DaysService, ApiVersionFactory) {

    return {

      api: {

        av_event: new ApiVersionFactory({
          url: '/v1/b2c/event',
          version: 'v2'
        }),

        list: function(props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['startTime', 'endTime', 'membershipId', 'saleChannel', 'tenantId']
            }
          });

          return $http({
            method: 'get',
            headers: {
              'x-b2c-tenant-id': props.tenantId
            },
            url: this.av_event.url + '/templates' + qs.query
          });
        },

        summaries: function(props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['startTime', 'endTime', 'membershipId', 'saleChannel', 'tenantId']
            }
          });

          return $http({
            method: 'get',
            headers: {
              'x-b2c-tenant-id': props.tenantId
            },
            url: this.av_event.url + '/templates/summaries' + qs.query
          });
        },

        slimSummaries: function(props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['startTime', 'endTime', 'membershipId', 'saleChannel', 'membershipIds', 'tenantId']
            }
          });

          return $http({
            method: 'get',
            headers: {
              'x-b2c-tenant-id': props.tenantId
            },
            url: this.av_event.url + '/templates/slim' + qs.query
          });
        },

        detail: function(props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: [ 'membershipId', 'membershipCategoryId', 'tenantId']
            }
          });

          return $http({
            method: 'get',
            headers: {
              'x-b2c-tenant-id': props.tenantId
            },
            url: this.av_event.url + '/templates/' + props.eventTemplateId + qs.query
          });
        },

        /*
        * @params props: {eventTemplateIds: [], membershipIds: [], saleChannel: string}
        */
        pricing: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'post',
            headers: {
              'x-b2c-tenant-id': props.tenantId
            },
            url: av.init({url: '/v1/b2c/event/templates/membership/pricing', version: 'v2'}),
            data: {
              membershipIds: props.membershipIds,
              eventTemplateId: props.eventTemplateId,
              saleChannel: 'online',
              eventStartTime: props.eventStartTime,
              eventEndTime: props.eventEndTime,
              membershipLevelIds: props.membershipLevelIds
            }
          });
        },

        instance: function(props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: [ 'membershipId', 'membershipCategoryId', 'tenantId']
            }
          });

          return $http({
            method: 'get',
            headers: {
              'x-b2c-tenant-id': props.tenantId
            },
            url: this.av_event.url + '/instances/' + props.eventId + qs.query
          });
        },

        times: function(props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['startTime', 'endTime', 'membershipId', 'comboTemplateId', 'saleChannel', 'membershipCategoryId', 'tenantId']
            }
          });

          return $http({
            method: 'get',
            headers: {
              'x-b2c-tenant-id': props.tenantId
            },
            url: this.av_event.url + '/templates/' + props.eventTemplateId + '/times' + qs.query
          });
        },

        calendar: function(props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['startTime', 'endTime', 'membershipId', 'saleChannel', 'tenantId']
            }
          });

          return $http({
            method: 'get',
            headers: {
              'x-b2c-tenant-id': props.tenantId
            },
            url: this.av_event.url + '/templates/calendar' + qs.query
          });
        },

        nextAvailable: function(props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['startTime', 'membershipId', 'saleChannel', 'tenantId']
            }
          });

          return $http({
            method: 'get',
            headers: {
              'x-b2c-tenant-id': props.tenantId
            },
            url: this.av_event.url + 's/' + props.eventTemplateId + '/nextavailable' + qs.query
          });
        },

        templateCalendar: function(props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['startTime', 'endTime', 'membershipId', 'saleChannel', 'tenantId']
            }
          });

          return $http({
            method: 'get',
            headers: {
              'x-b2c-tenant-id': props.tenantId
            },
            url: this.av_event.url + '/templates/' + props.eventTemplateId + '/calendar' + qs.query
          });
        }

      },

      init: function() {
        return true;
      },

      getPrimaryImage: function(event) {
        var i, ii,
            r = '';

        if (
          event.hasOwnProperty('images') && 
          event.images instanceof Array && 
          event.images.length > 0
        ) {
          for (i=0,ii=event.images.length;i<ii;i++) {
            if (event.images[i].primary) {
              r = event.images[i];
              break;
            }
          }
        } else if (event.primaryImage){
          r = event.primaryImage;
        }

        return r;
      },

      getAverageRating: function(stars, ratings) {
        var r = 0;
        if (stars > 0) {
          r = stars / ratings;
        }
        return r;
      },

      getDuration: function(duration, admissionType) {
        var r,
            hours,
            minutes;

        if (admissionType === 'generalAdmission') {
          r = ''; //'General admission times may vary';
        }else if (duration) {
          hours = (duration.hour > 1) ? duration.hour + ' hours' : (duration.hour > 0) ? duration.hour + ' hour' : '';
          minutes = (duration.minutes > 1) ? duration.minutes + ' minutes' : (duration.minutes > 0) ? duration.minutes + ' minute' : '';

          if (hours.length > 0) {
            r = hours + ' ' + minutes;
          }else{
            r = minutes;
          }
        }
        return r;
      },
      getTimes: function(schedules, repeatCycle, admissionType) {
        var i, ii;
        var j, jj;
        var r, k;
        var max = 5;
        var days = [];
        var times: TODO[] = [];
        var today = new Date();
        var day, dayFormat, todayDate, currentDate;
        var h, m, p;

        if (schedules) {
          for (i = 0, ii = schedules.length; i < ii; i++) {
            r = '';

            if (schedules[i].daysOfMonth instanceof Array && schedules[i].daysOfMonth.length > 0) {
              r += HelpersService.getEth(schedules[i].daysOfMonth[0]) + ' of every Month ';
            } else {
              if (schedules[i].monthly instanceof Array && schedules[i].monthly.length > 0) {
                r += ' Every ' + schedules[i].monthly[0] + ' ';
              }
              if (schedules[i].repeatCycle === 'year') {
                r += ' Once a year ';
              } else if (schedules[i].repeatCycle === 'never') {
                if (schedules[i].days && schedules[i].days instanceof Array && schedules[i].days.length > 0) {
                  days = schedules[i].days[0].split('-');
                  todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0);
                  currentDate = new Date(+days[0], +days[1] - 1, +days[2], 0, 0, 0, 0);
                  if (currentDate.getTime() >= todayDate.getTime()) {
                    r += days[1] + '/' + days[2] + '/' + days[0];
                  }else{
                    continue;
                  }
                } else {
                  r += ' Once ';
                }
              }
              if (schedules[i].weekdays) {
                if (schedules[i].weekdays.length === 7) {
                  r += 'Every day ';
                } else {
                  for (k = 0; k < schedules[i].weekdays.length; k += 1) {
                      day = schedules[i].weekdays[k];
                      dayFormat = DaysService.getFormattedDay('three', day);
                      r += dayFormat + ', ';
                  }
                }
              }
            }
            r += ' at ';

            if (admissionType === 'generalAdmission' && schedules[i].ranges instanceof Array) {
              for (j = 0, jj = schedules[i].ranges.length; j < jj; j++) {
                if (j > 0) {
                  r += ', ';
                  if (j === max) {
                    r += ' +' + (jj - j) + ' more... ';
                    break;
                  } else if (j === jj - 1) {
                    r += ' and ';
                  }
                }
                h = CalendarService.toHour(schedules[i].ranges[j].start.hour);
                m = CalendarService.toMinutes(schedules[i].ranges[j].start.minutes);
                p = CalendarService.getMeridian(schedules[i].ranges[j].start.hour);

                r += h;
                if (parseInt(m, 10) > 0) {
                  r += ':' + m;
                }
                r += ' ' + p;
                r += ' to ';

                h = CalendarService.toHour(schedules[i].ranges[j].end.hour);
                m = CalendarService.toMinutes(schedules[i].ranges[j].end.minutes);
                p = CalendarService.getMeridian(schedules[i].ranges[j].end.hour);

                r += h;
                if (parseInt(m, 10) > 0) {
                  r += ':' + m;
                }
                r += ' ' + p;
              }

            } else {
              for (j = 0, jj = schedules[i].hours.length; j < jj; j++) {
                if (j > 0) {
                  r += ', ';
                  if (j === max) {
                    r += ' +' + (jj - j) + ' more... ';
                    break;
                  } else if (j === jj - 1) {
                    r += ' and ';
                  }
                }
                h = CalendarService.toHour(schedules[i].hours[j].hour);
                m = CalendarService.toMinutes(schedules[i].hours[j].minutes);
                p = CalendarService.getMeridian(schedules[i].hours[j].hour);

                r += h;
                if (parseInt(m, 10) > 0) {
                  r += ':' + m;
                }
                r += ' ' + p;
              }
            }
            times.push({ description: r });
          }
        }

        return times;
      },
      getFacilityName: function(resources) {
        var i, ii,
            r = '';

        if (resources) {
          for (i = 0, ii = resources.length; i < ii; i++) {
            if (resources[i].resourceCategory === 'Facilities') {
              r = resources[i].type;
              break;
            }
          }
        }

        return r;
      },

      dateToSlotTime: function(date) {
        return this.getSlotTime($filter('date')(date, 'h:mma').toUpperCase());
      },

      getSlotTime: function(time) {
        var r = '',
            t, h, hrs, m, p, tz,
            st, hrs1, hrs2,
            h1, m1, p1, tz1,
            h2, m2, p2, tz2;

        if (time) {
          if (time.indexOf('-') > 0) {
            st = time.split(',')[0].split(' - ');
            hrs1 = st[0].split(':');
            hrs2 = st[1].split(':');

            h1 = hrs1[0].replace(/0(\d+)/, "$1");
            m1 = hrs1[1].replace(/(A|P)*M/gi, '');
            p1 = hrs1[1].replace(/\d+/g, '');

            h2 = hrs2[0].replace(/0(\d+)/, "$1");
            m2 = hrs2[1].replace(/(A|P)*M/gi, '');
            p2 = hrs2[1].replace(/\d+/g, '');

            r += h1;
            if (+m1 > 0) {
              r += ':' + m1;
            }

            r += ' ' + p1 + ' - ';

            r += h2;
            if (+m2 > 0) {
              r += ':' + m2;
            }

            r += ' ' + p2;

          } else {
            t = time.split(',');
            hrs = t[0].split(':');
            h = hrs[0].replace(/0(\d+)/, "$1");
            m = hrs[1].replace(/(A|P)*M/gi, '');
            p = hrs[1].replace(/\d+/g, '');
            tz = t[1];

            r += h;
            if (+m > 0) {
              r += ':' + m;
            }
            r += ' ' + p;
          }
        }

        return r;

      },

      hasRecommendations: function(event) {
        return (event &&
                event.hasOwnProperty('recommendations') &&
                event.recommendations.hasOwnProperty('recommendations') &&
                event.recommendations.recommendations instanceof Array &&
                event.recommendations.recommendations.length  > 0);
      },

      hasPrerequisites: function(event) {
        return (event &&
                event.hasOwnProperty('prerequisites') &&
                event.prerequisites.hasOwnProperty('requires') &&
                event.prerequisites.requires instanceof Array);
      },

      hasDependents: function(event) {
        return (event &&
                event.hasOwnProperty('dependents') &&
                event.dependents.hasOwnProperty('dependents') &&
                event.dependents.dependents instanceof Array);
      },

      hasSalesRules: function(event) {
        return (event &&
                event.hasOwnProperty('ruleSets') &&
                event.ruleSets.hasOwnProperty('associated') &&
                event.ruleSets.associated &&
                event.ruleSets.hasOwnProperty('ruleSetIds') &&
                event.ruleSets.ruleSetIds instanceof Array);
      },

      // TODO: For demo purposes only needs to be cleaned up
      isGAEvent: function(event) {
        return false; //(event && event.name && event.name.match(/General\s*Admission/));
      },

      hasGAPrerequisiteEvent: function(event, returnEvent) {

        var i, ii,
            r = false;

        if (this.hasPrerequisites(event)) {
          for (i=0,ii=event.prerequisites.requires.length;i<ii;i++) {
            if (this.isGAEvent(event.prerequisites.requires[i])) {
              r = (returnEvent) ? event.prerequisites.requires[i] : true;
              break;
            }
          }
        }

        return r;
      },

      getPrerequisiteEvent: function(event, name) {
        var r = false,
            i, ii,
            regEx = new RegExp(''+name, 'gi');

        // Only gets the first prerequisite event if no name is specified
        // Otherwise we perform a name match against each prerequisites
        // TODO: Enhance to support getting by ID
        if (this.hasPrerequisites(event)) {
          if (name) {
            for (i=0,ii=event.prerequisites.requires.length;i<ii;i++) {
              if (event.prerequisites.requires[i].name.match(regEx)) {
                r = event.prerequisites.requires[i];
                break;
              }
            }
          }else {
            r = event.prerequisites.requires[0];
          }
        }

        return r;
      }

    };

}]).name;
